import { useApiRequest } from "@/common/hooks/api/useApiRequest";
import { apiClient } from "@/core/api/ApiClient";
import { IntegrationApiClientDto, IntegrationApiClientReferenceDto } from "@/core/api/generated/v1";

import AppIcon from "../../Icons/AppIcon";
import BaseEntityInline, {
  BaseEntityInlineInheritableProps,
} from "../components/EntityInline/BaseEntityInline";

export interface IntegrationApiClientInlineProps extends BaseEntityInlineInheritableProps {
  entity: IntegrationApiClientDto | IntegrationApiClientReferenceDto | null | undefined;
  entityId?: string | null;
}

/** Inline brief information about the entity. */
export default function IntegrationApiClientInline({
  entity,
  entityId,
  ...otherProps
}: IntegrationApiClientInlineProps) {
  const request = useApiRequest(
    apiClient.integrationApiClientsApi.apiV1IntegrationApiClientsIntegrationApiClientIdGet,
    {
      nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
      integrationApiClientId: entityId!,
    },
    {
      deps: [entityId],
      skip: !entityId || !!entity,
    },
  );
  entity = request?.data || entity;

  const full = entity as IntegrationApiClientDto;
  // const ref = entity as IntegrationApiClientReferenceDto;

  return (
    <BaseEntityInline
      entity={entity}
      entityId={entityId}
      icon={<AppIcon of='integrationApiClient' inText />}
      content={<>{full && full.localNumber}</>}
      {...otherProps}
      tooltipTitle={otherProps?.tooltipTitle || "Integration API client"}
    />
  );
}
